/**
 * @fileoverview API service for early access lead submissions.
 * @module features/landing/api/earlyAccessApi
 */

import { supabase } from '@/lib/supabaseClient'

export interface EarlyAccessLead {
  email: string
  company: string
  website?: string | undefined
  monthly_revenue_index?: number | undefined
}

export interface SubmitLeadResult {
  success: boolean
  error?: 'duplicate_email' | 'unknown'
}

/**
 * Submit an early access lead to the database.
 * Uses Supabase anon client with RLS allowing public inserts.
 */
export async function submitEarlyAccessLead(lead: EarlyAccessLead): Promise<SubmitLeadResult> {
  const { error } = await supabase.from('early_access_leads').insert({
    email: lead.email.trim().toLowerCase(),
    company: lead.company.trim(),
    website: lead.website?.trim() || null,
    monthly_revenue_index: lead.monthly_revenue_index ?? null,
  })

  if (error) {
    // Unique constraint violation on email
    if (error.code === '23505') {
      return { success: false, error: 'duplicate_email' }
    }
    console.error('Failed to submit early access lead:', error)
    return { success: false, error: 'unknown' }
  }

  return { success: true }
}
